<template>
    <div class="container">
        <myheader name="资产数据库"></myheader>
        <div class="banner minwidth">
            <!-- <img class="banner-img" src="../../static/jjfa_banner.webp" alt=""> -->
            <div class="banner-text mx1360">
                <div class="title">
                    <p>公开资产数据库</p>
                </div>
                <div class="sub">
                    <p>输入您持有的资产证书编号，即可验证其在“环太湖链”上的数字身份。</p>
                </div>
                <div class="search-box flex-r-c-c">
                    <div class="sc-outer flex-r-c-c">
                        <div class="input-box">
                            <el-input placeholder="请输入18位证书编号，例如 CERT-2025001101-01" v-model.trim="keyword" clearable>
                            </el-input>
                        </div>
                        <div class="sc-icon-outer flex-c-c-c">
                            <div @click="searchDetail()" class="icon-box curadm">
                                <img class="search-icon" src="../../static/zcsjk_search_icon2.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- mx1360 -->
        <div class="mx1360 feature-box">
            <div class="ft-outer">
                <div class="title-box flex-c-c-c">
                    <div class="ft-title">价值发现：不止于备案，更在于洞察</div>
                    <div class="title-sub">每日精选已完成“数字护照”认证的代表性资产展示其背后的艺术、市场与数据价值 拷贝</div>
                </div>
                <div class="ft-list-outer">
                    <div class="at-list">
                        <el-row :gutter="20">
                            <el-col v-for="(e, i) in list" :xs="f_col(6) || 24" :sm="f_col(6) || 24" :md="f_col(6) || 12"
                                :lg="6">
                                <div @click="goPage(e)" :data-v='JSON.stringify(e)' class="at-box cur curadm">
                                    <div :data-v='JSON.stringify(e)' class="at-img-box">
                                        <img :data-v='JSON.stringify(e)' class="at-img cover" :src="e.img" alt="">
                                    </div>
                                    <div :data-v='JSON.stringify(e)' class="info-box">
                                        <div :data-v='JSON.stringify(e)' class="at-title hideLine1">{{ e.goods_name }}
                                        </div>
                                        <div :data-v='JSON.stringify(e)' class="tt-sub">
                                            <!-- 瓷器 | 清代 -->
                                            {{ e.type_name }}
                                        </div>
                                        <div :data-v='JSON.stringify(e)' class="tolink">
                                            查看数字档案 →
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="more-btn-outer cur flex-c-c-c">
                    <div @click="goPage2('/solution')" class="btn-box flex-c-c-c">了解更多>></div>
                </div>
            </div>
        </div>
        <div class="d-list-bk minwidth">
            <div class="mx1360">
                <div class="title-box flex-c-c-c">
                    <div class="b-title">
                        <p>我们如何构建可信的数字资产身份</p>
                    </div>
                    <div class="sub-t">
                        <p>我们通过一套严谨、科学的标准化流程</p>
                        <p>将物理世界的艺术品，映射为数字世界中独一无二、不可篡改的可信资产</p>
                    </div>
                </div>
                <div class="dm-box2 flex-c-c-c">
                    <div class="dm-main">
                        <div class="dm-img-box">
                            <img class="dm-img" src="../../static/zcsjk_diamond.png" alt="">
                        </div>
                        <div class="info-main">
                            <ul class="list-box">
                                <li class="list-li">
                                    <div class="img-box">
                                        <img src="../../static/zcsjk_icon_sand.png" class="icon-img"/>
                                    </div>
                                    <div class="text-box">
                                        <div class="title-box">艺术品物证DNA锁定</div>
                                        <div class="des-box">我们采用高倍显微、高光谱扫描等技术，在艺术品的稳定区域采集其独一无二的微观物理特征--如同人类的指纹。这些“物证DNA”数据将被加密存储，作为物理世界与数字世界锚定的第一把锁。</div>
                                    </div>
                                </li>
                                <li class="list-li">
                                    <div class="img-box">
                                        <img src="../../static/zcsjk_icon_link.png" class="icon-img"/>
                                    </div>
                                    <div class="text-box">
                                        <div class="title-box">PUF芯片与区块链上链</div>
                                        <div class="des-box">我们将物理防伪PUF芯片附着于艺术品之上，并将芯片ID与物证DNA数据、权属信息一同打包，通过加密哈希算法，在“环太湖链"上进行广播和存证。这形成了第二把锁，确保了权属信息的公开、透明与不可算改。</div>
                                    </div>
                                </li>
                                <li class="list-li">
                                    <div class="img-box">
                                        <img src="../../static/zcsjk_icon_edit.png" class="icon-img"/>
                                    </div>
                                    <div class="text-box">
                                        <div class="title-box">生成唯一的“数字资产护照”</div>
                                        <div class="des-box">完成上链后，系统将生成一份包含所有鉴证备案信息、流转记录和区块链地址的“数字资产护照”，并赋予其唯一的证书编号。您可以通过此编号，随时随地公开验证资产的真实性与权属。   </div>
                                    </div>
                                </li>
                                <li class="list-li">
                                    <div class="img-box">
                                        <img src="../../static/zcsjk_icon_dia.png" class="icon-img"/>
                                    </div>
                                    <div class="text-box">
                                        <div class="title-box">标准化的资产评估服务</div>
                                        <div class="des-box">在“确真"与“确权“的基础上，我们提供基于"艺术家IP全景评估体系”的科学价值评估服务。报告可被多家金融、司法机构采信，真正激活您手中艺术品的资产属性，赋能信贷、保险与交易。</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bt-btn-box flex-c-c-c">
                <div class="btn-des">现在就为您的珍藏赋予可信的数字身份。</div>
                <div class="btn-outer">
                    <div @click="goPage2('/solution')" class="btn-box curadm">免费注册并开始备案</div>
                </div>
            </div>
        </div>
        <myfooter></myfooter>

    </div>

</template>
<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js";

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "AssetDatabase",
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            list: [],
            swiperOption: {
                observer: true,
                observeSlideChildren: true,
                observeParents: true,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true
                // },
                preventClicks: false,
                loop: false,
                autoplay: {
                    pauseOnMouseEnter: true,
                    delay: 10000,
                    disableOnInteraction: false,
                },
                // navigation: {
                //     nextEl: '.el-carousel__arrow--right',
                //     prevEl: '.el-carousel__arrow--left'
                // },
                on: {
                    click: (event) => {
                        if (event.target.getAttribute('data-v')) {
                            // 这里的 obj 就是当前点击图片所对应的信息
                            let obj = JSON.parse(event.target.getAttribute('data-v'))
                            this.goPage(obj)
                        }
                    }
                }

            },
            keyword: ""
        }
    },
    mounted() {
        that = this;
        that.initData();
    },
    methods: {
        goPage2(path) {
			util.tourl(path)
		},
        goPage(e) {
            console.log(e)
            if (e.certificate_no) {
                util.tourl("/assetdetail", { certificate_no: e.certificate_no })
            } else {
                // util.vmsg("此艺术品尚未登记证书")
                util.valert("此艺术品尚未登记证书")

            }
        },
        searchDetail() {
            ty.ajax('web/web/search', { certificate_no: this.keyword }).then((result) => {
                if (result.data.data) {
                    util.tourl("/assetdetail", { certificate_no: this.keyword })
                }
            });
        },
        initData() {
            ty.ajax('web/web/search-list', {}).then((result) => {
                this.list = result.data.data
            });
        }
    },
}
</script>
<style lang="scss" scoped>
@import '../style.scss'; //所有页面公用
@import '../style2.scss'; //所有页面公用
@import './assetDatabase.scss';
</style>